import { userLogin, userLogout,userRegister,userActivate,userPasswordRules } from './models/UserLogin';
import { TDSAuthUrl } from './models/TDS';
import {
    searchClientNameAccount,
    getClientProfile,
    getClientAccDetail,
    getAccountContra,
    getMultiAccountContra,
    getAccountContract,
    getAccountContractDetail,
    getAccountContractSummary,
    getMultiAccountContract,
    getMultiAccountContractSummary,
    getMultiAccountContractDetail,
    getAccountSummary,
    getAccountFinancialList,
    getMultiFinancialList
} from './models/Account';

import { getTrustDetail,getTrustDetailOption } from './models/Trust';

import { getTradeHistory, getTradeHistorySummary,getTradeHistoryLogs } from './models/Trade';

import { getTeachAnalyzer } from './models/Tools'

import {
    heartbeat,
    getSessAck,
    getSessFeedAuth,
    changePassword,
    changeSecretAnswer,
    sessForgetPassword,
    sessValidateForgetPassword,
    sessUpdateForgetPassword,
    agreeTnc,
    forgetUserID,
    requestTAC,
    verifyTAC,
    resetPassword,
    unblockAccount
} from './models/Session';
import { getEstatementList } from './models/Estatement';

import {
    validateManualDeposit,
    submitFPX,
    submitDepositManualBulk,
    submitWithdrawal,
    submitSettlement,
    submitMultiSettlement,
    getFundingHistory,
    getMultiFundingHistory,
    getFundingTrust
} from './models/Funding';

import {
    getExchangeOptions,
    getStockOptions,
    getBankList,
    getEstatementTypes,
    getCurrency,
    getResearchCategory,
    getBroadcastType,
    getTradeCategories,
    getTradeStatus,
    getTradeCategoryTypes,
    getContractTypes,
    getContractStatus,
    getContractSettlementTypes,
    getFinancialTypes,
    getSides
} from './models/Property';
import { uploadFile, getTempFile, getFile,getEstatementFile } from './models/File';

import { getPortfolio,getPortfolioRealized,getPortfolioUnrealized,getPortfolioRealizedHistory,getPortfolioUnrealizedHistory,updatePortfolioUnrealizedHistoryPrice } from './models/Portfolio';
import {
    getTncDetail,
    getResearchList,
    getAnnoucementList
} from './models/Broadcast';

//available api function
function availableFunc() {
    return {
        userLogin,
        userLogout,
        userRegister,
        userActivate,
        userPasswordRules,
        // TDSAuthUrl,//abadon
        searchClientNameAccount,
        getClientProfile,
        getClientAccDetail,
        getAccountContra,
        getMultiAccountContra,

        getAccountContract, //contract information, settlement
        getAccountContractDetail,
        getAccountContractSummary, //get summary detail

        getMultiAccountContract, //multiple accounts contract
        getMultiAccountContractSummary,
        getMultiAccountContractDetail,

        //account
        getAccountSummary,
        getAccountFinancialList,
        getMultiFinancialList,


        //-----funding related-----//
        validateManualDeposit,
        submitFPX,
        submitDepositManualBulk,
        submitWithdrawal,
        submitSettlement,
        submitMultiSettlement,
        getFundingHistory,
        getFundingTrust,
        getMultiFundingHistory,

        //-----trust related-----//
        getTrustDetail,
        getTrustDetailOption,

        //-----trade related-----//
        getTradeHistory,
        getTradeHistorySummary,
        getTradeHistoryLogs,

        //-----get property-----//
        getExchangeOptions,
        getStockOptions,
        getBankList,
        getEstatementTypes,
        getCurrency,
        getResearchCategory,
        getBroadcastType,
        getTradeCategories,
        getTradeStatus,
        getTradeCategoryTypes,
        getContractTypes,
        getContractStatus,
        getContractSettlementTypes,
        getFinancialTypes,
        getSides,

        //-----upload file-----//
        uploadFile,
        getTempFile,
        getFile,
        getEstatementFile,

        //-----session related-----//
        heartbeat,
        getSessAck,
        getSessFeedAuth,
        changePassword,
        changeSecretAnswer,
        agreeTnc,
        forgetUserID,
        requestTAC,
        verifyTAC,
        resetPassword,
        unblockAccount,

        //-----estatement related-----//
        getEstatementList,

        //-----portfolio related-----//
        getPortfolio,
        getPortfolioRealized,
        getPortfolioRealizedHistory,
        getPortfolioUnrealized,
        getPortfolioUnrealizedHistory,
        updatePortfolioUnrealizedHistoryPrice,

        //----forget password related ---//
        sessForgetPassword,
        sessValidateForgetPassword,
        sessUpdateForgetPassword,

        //----broadcast ---//
        getTncDetail,
        getResearchList,
        getAnnoucementList,

        //----tools ---//
        getTeachAnalyzer
    };
}
export default availableFunc();
